import React from 'react';
import { COLORS } from '../../config/colors';

interface MaintenanceModalProps {
  isOpen: boolean;
  onClose: () => void;
}

const MaintenanceModal: React.FC<MaintenanceModalProps> = ({ isOpen, onClose }) => {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 z-[100] flex items-center justify-center bg-black/50 backdrop-blur-sm p-4 animate-in fade-in duration-300">
      <div 
        className="bg-white rounded-2xl shadow-2xl max-w-md w-full overflow-hidden transform transition-all animate-in zoom-in-95 duration-300"
        onClick={(e) => e.stopPropagation()}
      >
        <div className="p-8 text-center">
          <div 
            className="w-20 h-20 rounded-full flex items-center justify-center mx-auto mb-6"
            style={{ backgroundColor: `${COLORS.primary}15`, color: COLORS.primary }}
          >
            <i className="ri-tools-line text-4xl"></i>
          </div>
          
          <h2 className="text-2xl font-bold text-gray-800 mb-3">
            Page en travaux
          </h2>
          
          <p className="text-gray-600 mb-8 leading-relaxed">
            Cette page est actuellement indisponible pour travaux. Nous mettons tout en œuvre pour vous proposer ce service très prochainement.
          </p>
          
          <button
            onClick={onClose}
            className="w-full py-3 px-6 rounded-xl font-semibold text-white transition-all duration-300 hover:scale-[1.02] active:scale-[0.98] shadow-lg"
            style={{ 
              backgroundColor: COLORS.secondary,
              boxShadow: `0 10px 15px -3px ${COLORS.primary}40`
            }}
          >
            D'accord, j'ai compris
          </button>
        </div>
        
        <div className="bg-gray-50 px-8 py-4 border-t border-gray-100 flex justify-center">
          <span className="text-xs text-gray-400 font-medium uppercase tracking-wider">
            Équipe Technique Fred & Poppée
          </span>
        </div>
      </div>
      
      {/* Background overlay to close modal */}
      <div 
        className="absolute inset-0 -z-10" 
        onClick={onClose}
      />
    </div>
  );
};

export default MaintenanceModal;
